<template>
  <div
    :class="{'archive-hover-avatar position-relative': isHovered}"
    class="d-flex align-items-center justify-content-center w-4 h-4"
    title="Click to archive the company."
    @mouseenter="toggleHoverState"
    @mouseleave="toggleHoverState"
    @click="$emit('click')"
  >
    <img v-if="isHovered"
      style="transform: rotate(180deg)"
      src="@/assets/icons/arrow_down_square_hover.svg"
      alt="Archive icon (hovered)"
    />
    <img v-else
      style="transform: rotate(180deg)"
      src="@/assets/icons/arrow_down_square.svg"
      alt="Archive icon"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isHovered: false
    }
  },

  methods:  {
    toggleHoverState() {
      this.isHovered = !this.isHovered
    }
  }
}
</script>